<script setup>
</script>

<template>
    <svg
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M16.25 10.6954V15.0833C16.25 15.3944 16.1333 15.6667 15.9 15.9C15.6667 16.1333 15.3944 16.25 15.0833 16.25H3.41667C3.10556 16.25 2.83333 16.1333 2.6 15.9C2.36667 15.6667 2.25 15.3944 2.25 15.0833V3.41667C2.25 3.10556 2.36667 2.83333 2.6 2.6C2.83333 2.36667 3.10556 2.25 3.41667 2.25H7.80463V3.41667H3.41667V15.0833H15.0833V10.6954H16.25ZM7.34444 11.9917L6.52778 11.1556L14.2667 3.41667H10.0083V2.25H16.25V8.49167H15.0833V4.25278L7.34444 11.9917Z"
            fill="#6B7280"
        />
    </svg>
</template>
